<template>
  <div class="setting-notice module-item-style">
    <p class="setting-notice-title module-item-title-border-left">系统公告</p>
    <el-collapse accordion class="setting-notice-version-list" v-model="activeName"  @change="getDetailClick">
      <el-collapse-item v-for="(versionItem, i) in versionList" :key="versionItem.date" :name="versionItem.updateNum">
        <template slot="title">
          <div class="setting-notice-tab-head">
            <span class="version-title">
              <i v-if="versionItem.read == true" class="circle-icon"></i>
              <i v-else class="circle-icon-noread"></i>
              微聊 {{versionItem.version}} 版本更新</span>
            <span class="version-update-time">{{versionItem.date}}</span>
          </div>

        </template>
        <ul class="setting-notice-detail-container">
          <li v-for="(detailItem, index) in versionItem.detail" v-html="index + 1 +'、'+detailItem.content"></li>
        </ul>
      </el-collapse-item>
    </el-collapse>
    <pagenations
        :total="total"
        :size="size"
        @pageHandler="pageOperate"></pagenations>
  </div>
</template>

<script>
  import pagenations from '@/components/pagenations/pagenations'
  export default {
    name: 'setting-notice',
    components:{
      pagenations
    },
    data() {
      return {
        activeName:'',
        versionList: [],
        total:0,
        size:10,
        currentPage:1
      }
    },
    created() {
      this.getVersionList()
    },
    mounted() {

    },
    methods: {
      /**
       * 分页操作
       */
      pageOperate(val){
        if(val.type == 'currentChange'){
          this.currentPage = val.val
        }else if(val.type == "sizeChange"){
          this.size = val.val
        }
        this.getVersionList()
      },
      /**
       * 获取版本号列表
       */
      getVersionList() {
        this.$http.noticeAPI({
          pageNum: this.currentPage,
          pageSize:this.size
        }).then(res => {
          if (res.status == 1) {
            let version = res.data.data
            version.map(item => {
              item.detail = []
            })
            this.versionList = version
            this.total = res.data.total
            this.size = res.data.pageSize
          }
        }).catch(err => {
          console.log('err=', err)
        })
      },
      /**
       * 根据版本更新次数获取该版本的的详情
       * @param num
       */
      getVersionDetail(num){
        this.$http.noticeDetailAPI({num:num}).then( res => {
          if(res.status == 1){
            let ver = this.versionList
            let details = res.data

            ver.map( item => {
              if(item.updateNum == num){
                item.detail = details
              }
            })
            this.versionList = ver
          }
        }).catch( err => {

        })
      },
      /**
       * 标记更新次数未读数量
       * @param num
       */
      setLogIsReadNum(num){
        this.$http.setLogIsRead({num:num}).then( res => {
          if(res.status == 1){
           
          }
        }).catch( err => {

        })
      },
      /**
       * 展开该版本时去获取详情
       */
      getDetailClick(){
        this.versionList.map( item => {
          if(this.activeName == item.updateNum && item.detail.length == 0){
            this.getVersionDetail(this.activeName)
            this.setLogIsReadNum(this.activeName)
          }else if(item.detail.length != 0){
            this.getVersionList()
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .setting-notice {

    .setting-notice-title {
      margin-bottom: 34px;
    }

    .setting-notice-version-list {
      .el-collapse-item__header {
        padding: 0 21px;

        .setting-notice-tab-head {
          display: flex;
          width: 100%;
          justify-content: space-between;

          .circle-icon {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: rgba(191, 213, 243, 1);
            margin-right: 14px;
          }
          .circle-icon-noread {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: red;
            margin-right: 14px;
          }
          font-size: 14px;

          .version-title {
            color: #333;
          }

          .version-update-time {
            color: #999;
          }
        }
      }

      .el-collapse-item__header.is-active {
        background-color: rgba(230, 238, 249, 1);
      }

      .setting-notice-detail-container {
        padding-top: 10px;

        li {
          line-height: 26px;
          font-size: 13px;
          color: #666;
        }
      }
    }
  }
</style>
